import { useEffect, useMemo, useState } from "react";
import { Badge, Button, Card, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import api, { mediaUrl } from "../../api/axios";
import { DirectorySkeleton } from "../Common/Loading/PageSkeletons";

function CommunityDirectory() {
  const [businesses, setBusinesses] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/businesses")
      .then(({ data }) => setBusinesses(data || []))
      .catch(() => setBusinesses([]))
      .finally(() => setLoading(false));
  }, []);

  const filteredBusinesses = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return businesses;

    return businesses.filter(business => {
      const haystack = [
        business.name,
        business.slug,
        business.description,
        business.city,
        business.country
      ].filter(Boolean).join(" ").toLowerCase();
      return haystack.includes(normalizedQuery);
    });
  }, [businesses, query]);

  if (loading) {
    return (
      <Container className="page-band community-directory"><DirectorySkeleton /></Container>
    );
  }

  return (
    <Container className="page-band community-directory">
      <div className="community-directory-header mb-4">
        <div>
          <h1 className="section-title mb-1">Comunidades</h1>
          <p className="muted-copy mb-0">Tiendas, productos, coleccionistas y feeds locales dentro de Cardora.</p>
        </div>
        {localStorage.getItem("token") && (
          <Button as={Link} to="/stores/register" className="btn-cardora">
            Registrar tienda
          </Button>
        )}
      </div>

      <Row className="g-3 mb-4">
        <Col md={4}>
          <div className="store-metric">
            <span>Tiendas</span>
            <strong>{businesses.length}</strong>
          </div>
        </Col>
        <Col md={4}>
          <div className="store-metric">
            <span>Verificadas</span>
            <strong>{businesses.filter(business => business.is_verified).length}</strong>
          </div>
        </Col>
        <Col md={4}>
          <div className="store-metric">
            <span>Con ubicacion</span>
            <strong>{businesses.filter(business => business.city || business.address_line).length}</strong>
          </div>
        </Col>
      </Row>

      <Card className="cardora-card mb-4">
        <Card.Body>
          <InputGroup>
            <Form.Control
              value={query}
              onChange={event => setQuery(event.target.value)}
              placeholder="Buscar tienda, ciudad o comunidad..."
            />
            <Button variant="outline-dark" onClick={() => setQuery("")}>
              Limpiar
            </Button>
          </InputGroup>
        </Card.Body>
      </Card>

      <Row className="g-3">
        {filteredBusinesses.length === 0 && (
          <Col>
            <Card className="cardora-card">
              <Card.Body>No encontramos tiendas con ese criterio.</Card.Body>
            </Card>
          </Col>
        )}
        {filteredBusinesses.map(business => (
          <Col md={6} xl={4} key={business.id}>
            <Card className="cardora-card h-100 community-store-card">
              <div className="community-store-cover">
                {business.cover_url && <img src={mediaUrl(business.cover_url)} alt="" />}
              </div>
              <Card.Body>
                <div className="community-store-heading">
                  {business.logo_url ? (
                    <img src={mediaUrl(business.logo_url)} alt="" />
                  ) : (
                    <span>{business.name?.slice(0, 1) || "C"}</span>
                  )}
                  <div>
                    <div className="d-flex gap-2 align-items-center flex-wrap">
                      <Card.Title>{business.name}</Card.Title>
                      {business.is_verified && <Badge bg="success">Verificada</Badge>}
                      {!business.is_verified && business.verification_status && (
                        <Badge bg="light" text="dark">{business.verification_status}</Badge>
                      )}
                    </div>
                    <small>{[business.city, business.country].filter(Boolean).join(", ") || business.slug}</small>
                    <div className="community-store-mini-stats">
                      <span><i className="bi bi-people-fill" /> {business.followers_count || 0} seguidores</span>
                      <span className="community-store-stars" title="Valoracion de tienda pendiente">
                        <i className="bi bi-star" /><i className="bi bi-star" /><i className="bi bi-star" /><i className="bi bi-star" /><i className="bi bi-star" />
                      </span>
                    </div>
                  </div>
                </div>
                <Card.Text className="muted-copy mt-3">{business.description || "Comunidad local de coleccionistas."}</Card.Text>
                <div className="community-store-actions">
                  <Button as={Link} to={`/store/${business.slug}`} className="btn-cardora">
                    Ver comunidad
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default CommunityDirectory;


